import * as React from "react";
const SvgLetter = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 167,
	height: 181,
	viewBox: "0 0 167 181",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("g", { filter: "url(#filter0_dddd_1265_1198)" }, /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M154 125.467C154 129.854 154 132.047 153.146 133.723C152.395 135.197 151.197 136.395 149.723 137.146C148.047 138 145.854 138 141.467 138H25.5333C21.1463 138 18.9527 138 17.2771 137.146C15.8031 136.395 14.6048 135.197 13.8538 133.723C13 132.047 13 129.854 13 125.467V50.7076C13 48.2552 13 47.0291 13.338 45.916C13.6373 44.9307 14.1278 44.014 14.7817 43.2184C15.5203 42.3198 16.5406 41.6396 18.5811 40.2793L45.0925 22.605C46.2662 21.8226 46.853 21.4314 47.4878 21.1542C48.0513 20.9082 48.6418 20.7295 49.2471 20.6216C49.929 20.5 50.6343 20.5 52.0448 20.5H114.955C116.366 20.5 117.071 20.5 117.753 20.6216C118.358 20.7295 118.949 20.9082 119.512 21.1542C120.147 21.4314 120.734 21.8226 121.907 22.605L148.419 40.2793C150.459 41.6396 151.48 42.3198 152.218 43.2184C152.872 44.014 153.363 44.9307 153.662 45.916C154 47.0291 154 48.2552 154 50.7076V125.467Z",
	fill: "url(#paint0_linear_1265_1198)"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M154.49 125.467V125.49C154.49 127.664 154.49 129.325 154.381 130.651C154.272 131.988 154.05 133.027 153.582 133.945C152.785 135.511 151.511 136.784 149.945 137.582C149.027 138.05 147.988 138.272 146.651 138.381C145.325 138.49 143.664 138.49 141.489 138.49H141.467H25.5333H25.5105C23.3363 138.49 21.6747 138.49 20.3485 138.381C19.012 138.272 17.9731 138.05 17.0548 137.582C15.4888 136.784 14.2155 135.511 13.4176 133.945C12.9496 133.027 12.728 131.988 12.6188 130.651C12.5104 129.325 12.5104 127.664 12.5104 125.489V125.467V50.7076L12.5104 50.6108C12.5103 48.2505 12.5103 46.9567 12.8696 45.7738C13.1875 44.7268 13.7088 43.7528 14.4035 42.9076C15.1885 41.9525 16.2651 41.2348 18.229 39.9256L18.3095 39.8719L44.821 22.1976L44.8662 22.1675C45.997 21.4136 46.6172 21.0001 47.2919 20.7055C47.8906 20.4442 48.518 20.2542 49.1612 20.1396C49.8859 20.0104 50.6314 20.0104 51.9904 20.0104H52.0448H114.955H115.01C116.369 20.0104 117.114 20.0104 117.839 20.1396C118.482 20.2542 119.109 20.4442 119.708 20.7055C120.383 21.0001 121.003 21.4136 122.134 22.1674L122.179 22.1976L148.69 39.8719L148.771 39.9255C150.735 41.2348 151.811 41.9525 152.596 42.9076C153.291 43.7528 153.812 44.7268 154.13 45.7738C154.49 46.9567 154.49 48.2505 154.49 50.6107V50.7076V125.467Z",
	stroke: "url(#paint1_linear_1265_1198)",
	strokeWidth: .979167
})), /* @__PURE__ */ React.createElement("path", {
	opacity: .3,
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M141.467 137.021H25.5333C23.3236 137.021 21.7253 137.02 20.4682 136.917C19.2225 136.816 18.3984 136.619 17.7216 136.274C16.4319 135.617 15.3834 134.568 14.7262 133.279C14.3814 132.602 14.1844 131.778 14.0826 130.532C13.9799 129.275 13.9792 127.676 13.9792 125.467V50.7078C13.9792 48.1944 13.9891 47.1417 14.2749 46.2007C14.5368 45.3385 14.966 44.5364 15.5382 43.8403C16.1627 43.0805 17.033 42.4883 19.1242 41.0941L45.6357 23.4198C46.8373 22.6187 47.3423 22.2863 47.8795 22.0517C48.3726 21.8365 48.8893 21.6801 49.4189 21.5856C49.996 21.4828 50.6006 21.4793 52.0448 21.4793H114.955C116.399 21.4793 117.004 21.4828 117.581 21.5856C118.111 21.6801 118.627 21.8365 119.12 22.0517C119.658 22.2863 120.163 22.6187 121.364 23.4198L147.876 41.0941C149.967 42.4883 150.837 43.0805 151.462 43.8403C152.034 44.5364 152.463 45.3385 152.725 46.2007C153.011 47.1417 153.021 48.1944 153.021 50.7078V125.467C153.021 127.676 153.02 129.275 152.917 130.532C152.816 131.778 152.619 132.602 152.274 133.279C151.617 134.568 150.568 135.617 149.278 136.274C148.602 136.619 147.778 136.816 146.532 136.917C145.275 137.02 143.676 137.021 141.467 137.021ZM153.146 133.723C154 132.047 154 129.854 154 125.467V50.7078C154 48.2554 154 47.0292 153.662 45.9161C153.363 44.9308 152.872 44.0141 152.218 43.2185C151.48 42.3199 150.459 41.6397 148.419 40.2794L121.907 22.605C120.734 21.8227 120.147 21.4315 119.512 21.1544C118.949 20.9084 118.358 20.7296 117.753 20.6217C117.071 20.5001 116.366 20.5001 114.955 20.5001H52.0448C50.6343 20.5001 49.929 20.5001 49.2471 20.6217C48.6418 20.7296 48.0513 20.9084 47.4878 21.1544C46.853 21.4315 46.2662 21.8227 45.0927 22.605L45.0925 22.6051L18.581 40.2794C16.5406 41.6397 15.5203 42.3199 14.7817 43.2185C14.1278 44.0141 13.6373 44.9308 13.338 45.9161C13 47.0292 13 48.2554 13 50.7078V125.467C13 129.854 13 132.047 13.8538 133.723C14.6048 135.197 15.8031 136.395 17.2771 137.146C18.9527 138 21.1463 138 25.5333 138H141.467C145.854 138 148.047 138 149.723 137.146C151.197 136.395 152.395 135.197 153.146 133.723Z",
	fill: "#5B21B6",
	fillOpacity: .5
}), /* @__PURE__ */ React.createElement("g", {
	style: { mixBlendMode: "multiply" },
	filter: "url(#filter1_f_1265_1198)"
}, /* @__PURE__ */ React.createElement("path", {
	d: "M37.7307 31.0587C38.7503 28.2606 41.4437 26.4269 44.4208 26.5041L128.331 28.6779C131.596 28.7625 134.358 31.115 134.962 34.3245L143.13 77.7635C143.94 82.072 140.595 86.0406 136.212 85.9726L28.123 84.2968C23.3582 84.2229 20.0882 79.473 21.7198 74.9956L37.7307 31.0587Z",
	fill: "#3A0095",
	fillOpacity: .4
})), /* @__PURE__ */ React.createElement("path", {
	d: "M43.2274 0.740976C39.7931 0.44051 36.7654 2.98102 36.4649 6.41537L28.3576 99.0822C28.0572 102.517 30.5977 105.544 34.032 105.845L123.773 113.696C127.207 113.996 130.235 111.456 130.535 108.022L138.642 15.3547C138.943 11.9204 136.402 8.89272 132.968 8.59226L43.2274 0.740976Z",
	fill: "white"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M43.2274 0.740976C39.7931 0.44051 36.7654 2.98102 36.4649 6.41537L28.3576 99.0822C28.0572 102.517 30.5977 105.544 34.032 105.845L123.773 113.696C127.207 113.996 130.235 111.456 130.535 108.022L138.642 15.3547C138.943 11.9204 136.402 8.89272 132.968 8.59226L43.2274 0.740976Z",
	fill: "url(#paint2_linear_1265_1198)",
	fillOpacity: .02,
	style: { mixBlendMode: "multiply" }
}), /* @__PURE__ */ React.createElement("path", {
	d: "M43.2274 0.740976C39.7931 0.44051 36.7654 2.98102 36.4649 6.41537L28.3576 99.0822C28.0572 102.517 30.5977 105.544 34.032 105.845L123.773 113.696C127.207 113.996 130.235 111.456 130.535 108.022L138.642 15.3547C138.943 11.9204 136.402 8.89272 132.968 8.59226L43.2274 0.740976Z",
	stroke: "url(#paint3_linear_1265_1198)",
	strokeWidth: .734375
}), /* @__PURE__ */ React.createElement("path", {
	opacity: .4,
	d: "M33.0515 55.2621L37.3185 6.49005C37.5777 3.52708 40.1898 1.33527 43.1528 1.59449L132.893 9.44577C135.856 9.705 138.048 12.3171 137.789 15.2801L133.095 68.9293",
	stroke: "url(#paint4_linear_1265_1198)",
	strokeWidth: .734375
}), /* @__PURE__ */ React.createElement("mask", {
	id: "mask0_1265_1198",
	style: { maskType: "alpha" },
	maskUnits: "userSpaceOnUse",
	x: 13,
	y: -2,
	width: 141,
	height: 140
}, /* @__PURE__ */ React.createElement("path", {
	d: "M13 50.7076C13 48.2552 13 47.0291 13.338 45.916C13.6373 44.9307 14.1278 44.014 14.7817 43.2184C15.5203 42.3198 16.5406 41.6396 18.5811 40.2793L76.5478 1.63483C79.0604 -0.0402386 80.3167 -0.877771 81.6745 -1.20317C82.8745 -1.49073 84.1255 -1.49073 85.3255 -1.20317C86.6833 -0.877771 87.9396 -0.0402379 90.4522 1.63483L148.419 40.2793C150.459 41.6396 151.48 42.3198 152.218 43.2184C152.872 44.014 153.363 44.9307 153.662 45.916C154 47.0291 154 48.2552 154 50.7076V125.467C154 129.854 154 132.047 153.146 133.723C152.395 135.197 151.197 136.395 149.723 137.146C148.047 138 145.854 138 141.467 138H25.5333C21.1463 138 18.9527 138 17.2771 137.146C15.8031 136.395 14.6048 135.197 13.8538 133.723C13 132.047 13 129.854 13 125.467V50.7076Z",
	fill: "black"
})), /* @__PURE__ */ React.createElement("g", { mask: "url(#mask0_1265_1198)" }, /* @__PURE__ */ React.createElement("g", { filter: "url(#filter2_di_1265_1198)" }, /* @__PURE__ */ React.createElement("path", {
	d: "M13 44L13 138L60.9074 100.91C65.2665 97.5356 67.446 95.8483 68.2303 93.7946C68.9175 91.9949 68.9175 90.0051 68.2303 88.2054C67.446 86.1517 65.2665 84.4644 60.9074 81.0896L13 44Z",
	fill: "url(#paint5_linear_1265_1198)"
})), /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M12.0208 42.0037L12.0207 139.996L66.3071 97.9683C70.8641 94.4403 70.8641 87.5598 66.3071 84.0318L12.0208 42.0037ZM12.9999 44L65.7077 84.806C69.7583 87.942 69.7583 94.0581 65.7077 97.194L12.9999 138L12.9999 44Z",
	fill: "#475569",
	fillOpacity: .06
}), /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M154.912 42.0037L154.912 139.996L100.626 97.9683C96.0691 94.4403 96.069 87.5598 100.626 84.0318L154.912 42.0037ZM153.933 44L101.225 84.806C97.1748 87.942 97.1748 94.0581 101.225 97.194L153.933 138L153.933 44Z",
	fill: "#475569",
	fillOpacity: .06
}), /* @__PURE__ */ React.createElement("g", { filter: "url(#filter3_di_1265_1198)" }, /* @__PURE__ */ React.createElement("path", {
	d: "M154 44L154 138L106.093 100.91C101.734 97.5356 99.554 95.8483 98.7697 93.7946C98.0825 91.9949 98.0825 90.0051 98.7697 88.2054C99.554 86.1517 101.734 84.4644 106.093 81.0896L154 44Z",
	fill: "url(#paint6_linear_1265_1198)"
})), /* @__PURE__ */ React.createElement("g", {
	style: { mixBlendMode: "multiply" },
	opacity: .4
}, /* @__PURE__ */ React.createElement("g", { filter: "url(#filter4_f_1265_1198)" }, /* @__PURE__ */ React.createElement("path", {
	d: "M15.9375 138H151.062L91.8769 84.8187C88.9156 82.1579 87.435 80.8275 85.761 80.3228C84.2864 79.8783 82.7136 79.8783 81.239 80.3228C79.565 80.8275 78.0844 82.1579 75.1231 84.8187L15.9375 138Z",
	fill: "#334155",
	fillOpacity: .4
})), /* @__PURE__ */ React.createElement("g", { filter: "url(#filter5_f_1265_1198)" }, /* @__PURE__ */ React.createElement("path", {
	d: "M23.7708 138H143.229L92.8295 81.8169C89.5997 78.2164 87.9848 76.4162 86.0815 75.7518C84.4099 75.1683 82.5899 75.1683 80.9183 75.7518C79.015 76.4162 77.4001 78.2164 74.1703 81.8169L23.7708 138Z",
	fill: "#334155",
	fillOpacity: .2
})), /* @__PURE__ */ React.createElement("g", { filter: "url(#filter6_f_1265_1198)" }, /* @__PURE__ */ React.createElement("path", {
	d: "M15.9375 138H151.062L92.6667 75.3726C89.4804 71.9554 87.8873 70.2468 86.0245 69.6127C84.3876 69.0554 82.6124 69.0554 80.9755 69.6127C79.1127 70.2468 77.5196 71.9554 74.3333 75.3726L15.9375 138Z",
	fill: "#334155",
	fillOpacity: .1
}))), /* @__PURE__ */ React.createElement("g", { filter: "url(#filter7_i_1265_1198)" }, /* @__PURE__ */ React.createElement("path", {
	d: "M13 138H154L91.6783 84.3341C88.7767 81.8355 87.3259 80.5862 85.6976 80.1103C84.2626 79.6909 82.7374 79.6909 81.3024 80.1103C79.6741 80.5862 78.2233 81.8355 75.3217 84.3341L13 138Z",
	fill: "url(#paint7_linear_1265_1198)"
})), /* @__PURE__ */ React.createElement("path", {
	d: "M14.4688 136.042L75.2007 83.9242C78.1458 81.3969 79.6183 80.1332 81.2699 79.6523C82.7254 79.2285 84.2718 79.2294 85.7269 79.6549C87.3779 80.1376 88.8489 81.403 91.7911 83.9336L153.51 137.021",
	stroke: "#475569",
	strokeOpacity: .06,
	strokeWidth: .979167
}), /* @__PURE__ */ React.createElement("g", { filter: "url(#filter8_f_1265_1198)" }, /* @__PURE__ */ React.createElement("path", {
	d: "M13 62.1146L13 138H154V62.1146",
	stroke: "url(#paint8_linear_1265_1198)",
	strokeWidth: 15.6667
})), /* @__PURE__ */ React.createElement("path", {
	d: "M13 47.9166V125.467C13 129.854 13 132.047 13.8538 133.723C14.6048 135.197 15.8031 136.395 17.2771 137.146C18.9527 138 21.1463 138 25.5333 138H141.467C145.854 138 148.047 138 149.723 137.146C151.197 136.395 152.395 135.197 153.146 133.723C154 132.047 154 129.854 154 125.467V47.9166",
	stroke: "white",
	strokeOpacity: .4,
	strokeWidth: 1.95833,
	strokeLinecap: "round"
})), /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M84.0139 29.2655C85.9078 29.4312 87.322 31.11 87.1569 32.9962C86.9919 34.8824 85.3077 36.2901 83.4138 36.1244C81.5202 35.9587 80.106 34.28 80.271 32.3938C80.4361 30.5075 82.1203 29.0999 84.0139 29.2655ZM84.1551 27.6517C81.3705 27.4081 78.8935 29.4783 78.6508 32.252C78.4081 35.0261 80.488 37.4946 83.2726 37.7382C86.0575 37.9819 88.5345 35.912 88.7772 33.138C89.0198 30.3642 86.94 27.8953 84.1551 27.6517Z",
	fill: "black"
}), /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M92.8918 28.4047L88.9849 28.0629C90.1946 29.4513 90.8633 31.3151 90.6901 33.2939C90.517 35.2728 89.5348 36.9921 88.1024 38.1494L92.0094 38.4912C94.7619 38.732 97.2121 36.6598 97.4548 33.8858C97.6975 31.112 95.6444 28.6455 92.8918 28.4047Z",
	fill: "#FFB224"
}), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("filter", {
	id: "filter0_dddd_1265_1198",
	x: .270752,
	y: 17.5625,
	width: 166.458,
	height: 162.542,
	filterUnits: "userSpaceOnUse",
	colorInterpolationFilters: "sRGB"
}, /* @__PURE__ */ React.createElement("feFlood", {
	floodOpacity: 0,
	result: "BackgroundImageFix"
}), /* @__PURE__ */ React.createElement("feColorMatrix", {
	in: "SourceAlpha",
	type: "matrix",
	values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
	result: "hardAlpha"
}), /* @__PURE__ */ React.createElement("feOffset", { dy: 1.95833 }), /* @__PURE__ */ React.createElement("feGaussianBlur", { stdDeviation: 1.95833 }), /* @__PURE__ */ React.createElement("feColorMatrix", {
	type: "matrix",
	values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.08 0"
}), /* @__PURE__ */ React.createElement("feBlend", {
	mode: "normal",
	in2: "BackgroundImageFix",
	result: "effect1_dropShadow_1265_1198"
}), /* @__PURE__ */ React.createElement("feColorMatrix", {
	in: "SourceAlpha",
	type: "matrix",
	values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
	result: "hardAlpha"
}), /* @__PURE__ */ React.createElement("feOffset", { dy: 7.83333 }), /* @__PURE__ */ React.createElement("feGaussianBlur", { stdDeviation: 3.91667 }), /* @__PURE__ */ React.createElement("feColorMatrix", {
	type: "matrix",
	values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.07 0"
}), /* @__PURE__ */ React.createElement("feBlend", {
	mode: "normal",
	in2: "effect1_dropShadow_1265_1198",
	result: "effect2_dropShadow_1265_1198"
}), /* @__PURE__ */ React.createElement("feColorMatrix", {
	in: "SourceAlpha",
	type: "matrix",
	values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
	result: "hardAlpha"
}), /* @__PURE__ */ React.createElement("feOffset", { dy: 16.6458 }), /* @__PURE__ */ React.createElement("feGaussianBlur", { stdDeviation: 4.89583 }), /* @__PURE__ */ React.createElement("feColorMatrix", {
	type: "matrix",
	values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.04 0"
}), /* @__PURE__ */ React.createElement("feBlend", {
	mode: "normal",
	in2: "effect2_dropShadow_1265_1198",
	result: "effect3_dropShadow_1265_1198"
}), /* @__PURE__ */ React.createElement("feColorMatrix", {
	in: "SourceAlpha",
	type: "matrix",
	values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
	result: "hardAlpha"
}), /* @__PURE__ */ React.createElement("feOffset", { dy: 29.375 }), /* @__PURE__ */ React.createElement("feGaussianBlur", { stdDeviation: 5.875 }), /* @__PURE__ */ React.createElement("feColorMatrix", {
	type: "matrix",
	values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.01 0"
}), /* @__PURE__ */ React.createElement("feBlend", {
	mode: "normal",
	in2: "effect3_dropShadow_1265_1198",
	result: "effect4_dropShadow_1265_1198"
}), /* @__PURE__ */ React.createElement("feBlend", {
	mode: "normal",
	in: "SourceGraphic",
	in2: "effect4_dropShadow_1265_1198",
	result: "shape"
})), /* @__PURE__ */ React.createElement("filter", {
	id: "filter1_f_1265_1198",
	x: 11.5035,
	y: 16.71,
	width: 141.539,
	height: 79.0551,
	filterUnits: "userSpaceOnUse",
	colorInterpolationFilters: "sRGB"
}, /* @__PURE__ */ React.createElement("feFlood", {
	floodOpacity: 0,
	result: "BackgroundImageFix"
}), /* @__PURE__ */ React.createElement("feBlend", {
	mode: "normal",
	in: "SourceGraphic",
	in2: "BackgroundImageFix",
	result: "shape"
}), /* @__PURE__ */ React.createElement("feGaussianBlur", {
	stdDeviation: 4.89583,
	result: "effect1_foregroundBlur_1265_1198"
})), /* @__PURE__ */ React.createElement("filter", {
	id: "filter2_di_1265_1198",
	x: 11.0417,
	y: 38.125,
	width: 75.3289,
	height: 113.583,
	filterUnits: "userSpaceOnUse",
	colorInterpolationFilters: "sRGB"
}, /* @__PURE__ */ React.createElement("feFlood", {
	floodOpacity: 0,
	result: "BackgroundImageFix"
}), /* @__PURE__ */ React.createElement("feColorMatrix", {
	in: "SourceAlpha",
	type: "matrix",
	values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
	result: "hardAlpha"
}), /* @__PURE__ */ React.createElement("feOffset", {
	dx: 7.83333,
	dy: 3.91667
}), /* @__PURE__ */ React.createElement("feGaussianBlur", { stdDeviation: 4.89583 }), /* @__PURE__ */ React.createElement("feComposite", {
	in2: "hardAlpha",
	operator: "out"
}), /* @__PURE__ */ React.createElement("feColorMatrix", {
	type: "matrix",
	values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /* @__PURE__ */ React.createElement("feBlend", {
	mode: "normal",
	in2: "BackgroundImageFix",
	result: "effect1_dropShadow_1265_1198"
}), /* @__PURE__ */ React.createElement("feBlend", {
	mode: "normal",
	in: "SourceGraphic",
	in2: "effect1_dropShadow_1265_1198",
	result: "shape"
}), /* @__PURE__ */ React.createElement("feColorMatrix", {
	in: "SourceAlpha",
	type: "matrix",
	values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
	result: "hardAlpha"
}), /* @__PURE__ */ React.createElement("feOffset", { dy: .979167 }), /* @__PURE__ */ React.createElement("feComposite", {
	in2: "hardAlpha",
	operator: "arithmetic",
	k2: -1,
	k3: 1
}), /* @__PURE__ */ React.createElement("feColorMatrix", {
	type: "matrix",
	values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
}), /* @__PURE__ */ React.createElement("feBlend", {
	mode: "normal",
	in2: "shape",
	result: "effect2_innerShadow_1265_1198"
})), /* @__PURE__ */ React.createElement("filter", {
	id: "filter3_di_1265_1198",
	x: 80.6294,
	y: 38.125,
	width: 75.3289,
	height: 113.583,
	filterUnits: "userSpaceOnUse",
	colorInterpolationFilters: "sRGB"
}, /* @__PURE__ */ React.createElement("feFlood", {
	floodOpacity: 0,
	result: "BackgroundImageFix"
}), /* @__PURE__ */ React.createElement("feColorMatrix", {
	in: "SourceAlpha",
	type: "matrix",
	values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
	result: "hardAlpha"
}), /* @__PURE__ */ React.createElement("feOffset", {
	dx: -7.83333,
	dy: 3.91667
}), /* @__PURE__ */ React.createElement("feGaussianBlur", { stdDeviation: 4.89583 }), /* @__PURE__ */ React.createElement("feComposite", {
	in2: "hardAlpha",
	operator: "out"
}), /* @__PURE__ */ React.createElement("feColorMatrix", {
	type: "matrix",
	values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /* @__PURE__ */ React.createElement("feBlend", {
	mode: "normal",
	in2: "BackgroundImageFix",
	result: "effect1_dropShadow_1265_1198"
}), /* @__PURE__ */ React.createElement("feBlend", {
	mode: "normal",
	in: "SourceGraphic",
	in2: "effect1_dropShadow_1265_1198",
	result: "shape"
}), /* @__PURE__ */ React.createElement("feColorMatrix", {
	in: "SourceAlpha",
	type: "matrix",
	values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
	result: "hardAlpha"
}), /* @__PURE__ */ React.createElement("feOffset", { dy: .979167 }), /* @__PURE__ */ React.createElement("feComposite", {
	in2: "hardAlpha",
	operator: "arithmetic",
	k2: -1,
	k3: 1
}), /* @__PURE__ */ React.createElement("feColorMatrix", {
	type: "matrix",
	values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
}), /* @__PURE__ */ React.createElement("feBlend", {
	mode: "normal",
	in2: "shape",
	result: "effect2_innerShadow_1265_1198"
})), /* @__PURE__ */ React.createElement("filter", {
	id: "filter4_f_1265_1198",
	x: 12.0208,
	y: 76.0727,
	width: 142.958,
	height: 65.844,
	filterUnits: "userSpaceOnUse",
	colorInterpolationFilters: "sRGB"
}, /* @__PURE__ */ React.createElement("feFlood", {
	floodOpacity: 0,
	result: "BackgroundImageFix"
}), /* @__PURE__ */ React.createElement("feBlend", {
	mode: "normal",
	in: "SourceGraphic",
	in2: "BackgroundImageFix",
	result: "shape"
}), /* @__PURE__ */ React.createElement("feGaussianBlur", {
	stdDeviation: 1.95833,
	result: "effect1_foregroundBlur_1265_1198"
})), /* @__PURE__ */ React.createElement("filter", {
	id: "filter5_f_1265_1198",
	x: 12.0208,
	y: 63.5642,
	width: 142.958,
	height: 86.1858,
	filterUnits: "userSpaceOnUse",
	colorInterpolationFilters: "sRGB"
}, /* @__PURE__ */ React.createElement("feFlood", {
	floodOpacity: 0,
	result: "BackgroundImageFix"
}), /* @__PURE__ */ React.createElement("feBlend", {
	mode: "normal",
	in: "SourceGraphic",
	in2: "BackgroundImageFix",
	result: "shape"
}), /* @__PURE__ */ React.createElement("feGaussianBlur", {
	stdDeviation: 5.875,
	result: "effect1_foregroundBlur_1265_1198"
})), /* @__PURE__ */ React.createElement("filter", {
	id: "filter6_f_1265_1198",
	x: -7.5625,
	y: 45.6947,
	width: 182.125,
	height: 115.805,
	filterUnits: "userSpaceOnUse",
	colorInterpolationFilters: "sRGB"
}, /* @__PURE__ */ React.createElement("feFlood", {
	floodOpacity: 0,
	result: "BackgroundImageFix"
}), /* @__PURE__ */ React.createElement("feBlend", {
	mode: "normal",
	in: "SourceGraphic",
	in2: "BackgroundImageFix",
	result: "shape"
}), /* @__PURE__ */ React.createElement("feGaussianBlur", {
	stdDeviation: 11.75,
	result: "effect1_foregroundBlur_1265_1198"
})), /* @__PURE__ */ React.createElement("filter", {
	id: "filter7_i_1265_1198",
	x: 13,
	y: 79.7958,
	width: 141,
	height: 58.2045,
	filterUnits: "userSpaceOnUse",
	colorInterpolationFilters: "sRGB"
}, /* @__PURE__ */ React.createElement("feFlood", {
	floodOpacity: 0,
	result: "BackgroundImageFix"
}), /* @__PURE__ */ React.createElement("feBlend", {
	mode: "normal",
	in: "SourceGraphic",
	in2: "BackgroundImageFix",
	result: "shape"
}), /* @__PURE__ */ React.createElement("feColorMatrix", {
	in: "SourceAlpha",
	type: "matrix",
	values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
	result: "hardAlpha"
}), /* @__PURE__ */ React.createElement("feOffset", { dy: .979167 }), /* @__PURE__ */ React.createElement("feComposite", {
	in2: "hardAlpha",
	operator: "arithmetic",
	k2: -1,
	k3: 1
}), /* @__PURE__ */ React.createElement("feColorMatrix", {
	type: "matrix",
	values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
}), /* @__PURE__ */ React.createElement("feBlend", {
	mode: "normal",
	in2: "shape",
	result: "effect1_innerShadow_1265_1198"
})), /* @__PURE__ */ React.createElement("filter", {
	id: "filter8_f_1265_1198",
	x: -2.66658,
	y: 54.2813,
	width: 172.333,
	height: 99.3854,
	filterUnits: "userSpaceOnUse",
	colorInterpolationFilters: "sRGB"
}, /* @__PURE__ */ React.createElement("feFlood", {
	floodOpacity: 0,
	result: "BackgroundImageFix"
}), /* @__PURE__ */ React.createElement("feBlend", {
	mode: "normal",
	in: "SourceGraphic",
	in2: "BackgroundImageFix",
	result: "shape"
}), /* @__PURE__ */ React.createElement("feGaussianBlur", {
	stdDeviation: 3.91667,
	result: "effect1_foregroundBlur_1265_1198"
})), /* @__PURE__ */ React.createElement("linearGradient", {
	id: "paint0_linear_1265_1198",
	x1: 54.125,
	y1: 116.458,
	x2: 110.917,
	y2: 45.9583,
	gradientUnits: "userSpaceOnUse"
}, /* @__PURE__ */ React.createElement("stop", { stopColor: "#FDC830" }), /* @__PURE__ */ React.createElement("stop", {
	offset: 1,
	stopColor: "#F37335"
})), /* @__PURE__ */ React.createElement("linearGradient", {
	id: "paint1_linear_1265_1198",
	x1: 83.5,
	y1: 138,
	x2: 83.5,
	y2: 20.5,
	gradientUnits: "userSpaceOnUse"
}, /* @__PURE__ */ React.createElement("stop", {
	stopColor: "#475569",
	stopOpacity: .06
}), /* @__PURE__ */ React.createElement("stop", {
	offset: 1,
	stopColor: "#475569",
	stopOpacity: 0
})), /* @__PURE__ */ React.createElement("linearGradient", {
	id: "paint2_linear_1265_1198",
	x1: 46.9205,
	y1: 14.7022,
	x2: 116.592,
	y2: 117.123,
	gradientUnits: "userSpaceOnUse"
}, /* @__PURE__ */ React.createElement("stop", {
	stopColor: "#9116C2",
	stopOpacity: .13
}), /* @__PURE__ */ React.createElement("stop", {
	offset: .538584,
	stopColor: "#9A01D6"
}), /* @__PURE__ */ React.createElement("stop", {
	offset: .955042,
	stopColor: "#FF91CC"
})), /* @__PURE__ */ React.createElement("linearGradient", {
	id: "paint3_linear_1265_1198",
	x1: 88.0657,
	y1: 5.03241,
	x2: 78.9343,
	y2: 109.405,
	gradientUnits: "userSpaceOnUse"
}, /* @__PURE__ */ React.createElement("stop", {
	stopColor: "#422C84",
	stopOpacity: .06
}), /* @__PURE__ */ React.createElement("stop", {
	offset: 1,
	stopColor: "#475569",
	stopOpacity: 0
})), /* @__PURE__ */ React.createElement("linearGradient", {
	id: "paint4_linear_1265_1198",
	x1: 138.789,
	y1: 9.47033,
	x2: 69.4295,
	y2: 77.6117,
	gradientUnits: "userSpaceOnUse"
}, /* @__PURE__ */ React.createElement("stop", { stopColor: "white" }), /* @__PURE__ */ React.createElement("stop", {
	offset: .486575,
	stopColor: "white",
	stopOpacity: 0
})), /* @__PURE__ */ React.createElement("linearGradient", {
	id: "paint5_linear_1265_1198",
	x1: 43.3542,
	y1: 138,
	x2: 43.3542,
	y2: 44,
	gradientUnits: "userSpaceOnUse"
}, /* @__PURE__ */ React.createElement("stop", {
	offset: .28125,
	stopColor: "#EEF0F1"
}), /* @__PURE__ */ React.createElement("stop", {
	offset: .78125,
	stopColor: "#F9FAFA"
})), /* @__PURE__ */ React.createElement("linearGradient", {
	id: "paint6_linear_1265_1198",
	x1: 123.646,
	y1: 138,
	x2: 123.646,
	y2: 44,
	gradientUnits: "userSpaceOnUse"
}, /* @__PURE__ */ React.createElement("stop", {
	offset: .28125,
	stopColor: "#EEF0F1"
}), /* @__PURE__ */ React.createElement("stop", {
	offset: .78125,
	stopColor: "#F9FAFA"
})), /* @__PURE__ */ React.createElement("linearGradient", {
	id: "paint7_linear_1265_1198",
	x1: 83.5,
	y1: 77.2917,
	x2: 83.5,
	y2: 138,
	gradientUnits: "userSpaceOnUse"
}, /* @__PURE__ */ React.createElement("stop", {
	offset: .322581,
	stopColor: "#FAFAFB"
}), /* @__PURE__ */ React.createElement("stop", {
	offset: 1,
	stopColor: "#EEF0F1"
})), /* @__PURE__ */ React.createElement("linearGradient", {
	id: "paint8_linear_1265_1198",
	x1: 83.5,
	y1: 62.8238,
	x2: 83.5,
	y2: 138,
	gradientUnits: "userSpaceOnUse"
}, /* @__PURE__ */ React.createElement("stop", { stopColor: "#F9FAFA" }), /* @__PURE__ */ React.createElement("stop", {
	offset: .693396,
	stopColor: "#EEF0F1"
}))));
export default SvgLetter;
